import { render } from "./departmentalCapacity.vue?vue&type=template&id=b4badee4&scoped=true&ts=true&lang=pug"
import script from "./departmentalCapacity.vue?vue&type=script&lang=ts"
export * from "./departmentalCapacity.vue?vue&type=script&lang=ts"

import "./departmentalCapacity.vue?vue&type=style&index=0&id=b4badee4&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4badee4"]])

export default __exports__